import React from 'react';
import { Link } from 'react-router-dom';

const Main = () => {
  return (
    <div>
      <div id="main_visual_warp">
        <div className="main_visual_text">
          <p>   <img src='img10/main_text_logo.png' alt="Main Text Logo" /></p>
          <p className="main_text01">
            캐치는 <span className="my-10px">변화와 성장</span>하는 <br />
            기업입니다.
          </p>
          <p className="main_text02">
            빠르게 변화하는 시대와 맞춰 고객과 함께 <br />
            성장하는 기업이 되겠습니다.
          </p>
        </div>
      </div>
      <div className="main_title">
        <p className="main_title_text01"><span style={{ color: '#063680' }}>CATCH</span> Delivery</p>
        <p className="main_title_text02">모두가 만족하는 서비스를 제공합니다.</p>
      </div>
      <div className="main_con01">
        <div className="main_con01-2" style={{ position: 'relative', textAlign: 'center' }}>
          <div className="main_con01-1">
            아마존 AWS 클라우드<span className="br_mobile" /> 서버 <span className="br_pc" />
            기반으로 안정성 상승
          </div>

          <img src="img10/main_con01-1.png" alt='main_con01-1' />

        </div>
        <div className="main_con01-2" style={{ position: 'relative', textAlign: 'center' }}>
          <div className="main_con01-1">
            크로스 플랫폼 웹기반으로  <span className="br_pc" />
            프로그램 오류 최적화
          </div>

          <img src="img10/main_con01-2.png" alt='main_con01-2' />

        </div>
        <div className="main_con01-2" style={{ position: 'relative', textAlign: 'center' }}>
          <div className="main_con01-1">
            베테랑 개발자로 구성된  <span className="br_pc" /><span className="br_mobile" />
            개발팀 신속한 피드백 가능
          </div>
          <img src="img10/main_con01-3.png" alt='main_con01-3' />
        </div>
        <div className="main_con01-2" style={{ position: 'relative', textAlign: 'center' }}>
          <div className="main_con01-1">
            편리한  <span className="br_pc" />
            세무처리
          </div>
          <img src="img10/main_con01-4.png" alt='main_con01-4' />
        </div>
      </div>
      <div id="main_con02_warp">
        <div className="main_title">
          <p className="main_title_text03">CATCH Partner</p>
          <p className="main_title_text04">캐치는 여러 파트너스와 함께 하고 있습니다.</p>
        </div>
        <div className="main_con02-1">
          <img src="img10/main_con02-1.png" alt='main_con02-1' />
        </div>
        <div className="main_con02-1_m">
          <img src="img10/main_con02-1_m.png" alt='main_con01-2m' />
        </div>
      </div>
      <div className="main_title">
        <p className="main_title_text01"><span style={{ color: '#063680' }}>CATCH</span> Program</p>
        <p className="main_title_text02">캐치 프로그램을 사용해보세요.</p>
      </div>
      <div id="main_con03_warp">
        <div className="main_con03">
          <div className="main_con03_left">
            <p className="main_con03_text01">01</p>
            <p className="main_con03_text02">관제 프로그램</p>
            <p className="main_con03_text03">
              - 사용자에 편의에 따라 커스텀 설정 가능 <br />
              - 관제 프로그램 다운로드 없이 사용 가능
            </p>
          </div>
          <div className="main_con03_right">
            <img src="img10/main_con03-1.png" alt='main_con03-1' />
          </div>
        </div>
        <div className="main_con03-2">
          <div className="main_con03-2_left">
            <img src="img10/main_con03-2.png" alt='main_con03-2' />
          </div>
          <div className="main_con03-2_right">
            <p className="main_con03_text01">02</p>
            <p className="main_con03_text02">가맹점 프로그램</p>
            <p className="main_con03_text03">
              - 남녀노소 쉽게 사용 가능한 간편한 조작 <br />
              - 포스 연동 전문인력 배치<br />
              - 예치금 카드충전 가능
            </p>
          </div>
        </div>
        <div className="main_con03-2_m">
          <div className="main_con03-2_left_m">
            <p className="main_con03_text01">02</p>
            <p className="main_con03_text02">가맹점 프로그램</p>
            <p className="main_con03_text03">
              - 남녀노소 쉽게 사용 가능한 간편한 조작 <br />
              - 포스 연동 전문인력 배치<br />
              - 예치금 카드충전 가능
            </p>
          </div>
          <div className="main_con03-2_right_m">
            <img src="img10/main_con03-2.png" alt='main_con03-2' />
            {/* <img src={MainCon032} /> */}
          </div>
        </div>
        <div className="main_con03">
          <div className="main_con03_left">
            <p className="main_con03_text01">03</p>
            <p className="main_con03_text02">라이더 프로그램</p>
            <p className="main_con03_text03">
              - 라이더 예치금 즉시 출금 <br />
              - 실시간 오더위치 확인 <br />
              - 깔끔한 UI 디자인 <br />
              - 편리한 인터페이스로 쉽고 빠르게 조작 가능
            </p>
          </div>
          <div className="main_con03_right">
            <img src="img10/main_con03-3.png" alt='main_con03-3' />
          </div>
        </div>
      </div>
      <div style={{ clear: 'both' }} />
      <div id="main_con04_warp">
        <div className="main_con04">
          <p className="main_con04_text00"><img src="img10/main_con04-1.png" alt='main_con04-1' /></p>
          <p className="main_con04_text01">
            가맹점주님과 라이더님의 문의를<br />
            항시 기다리고 있습니다.
          </p>
          <p className="main_con04_text02">
            <Link to="/inquiry"><img src="img10/main_con04_btn.png" alt='main_con04_btn' /></Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Main;
